module.exports = "<bar-bg #barBg id=\"barBg\"></bar-bg>    "